import CityPageTemplate from "../city-template/CityPageTemplate";
import { berkeleyConfig } from "./data";

export default function BerkeleyPage() {
  return <CityPageTemplate config={berkeleyConfig} />;
}